import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateFacebookCampaignMutation,
  UpdateFacebookCampaignMutationVariables
} from './__generated__/UpdateFacebookCampaignMutation';

const UPDATE_FACEBOOK_CAMPAIGN_MUTATION = gql`
  mutation UpdateFacebookCampaignMutation($id: ID!, $facebookCampaignParams: FacebookCampaignParams!) {
    updateFacebookCampaign(id: $id, facebookCampaignParams: $facebookCampaignParams) {
      campaign {
        id
      }
      errors {
        attribute
        messages
        fullMessages
      }
    }
  }
`;

export const useUpdateFacebookCampaign = () => {
  return useMutation<UpdateFacebookCampaignMutation, UpdateFacebookCampaignMutationVariables>(
    UPDATE_FACEBOOK_CAMPAIGN_MUTATION,
    { client: kmsClient }
  );
};
